import { atom, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';
import PublicProfile, {
  andTagAtom,
} from '../../../components/WebCard/RegularPublicProfile';

export const actionAtom = atom<string | null>(null);

export default function RegularWebCardPage() {
  const { id } = useParams();

  const setAndTag = useSetAtom(andTagAtom);

  if (!id) {
    return <LoadingOverlay />;
  }
  setAndTag(id);

  return (
    <Suspense fallback={<LoadingOverlay />}>
      <PublicProfile andTag={id} modalMode="center" />
    </Suspense>
  );
}
